'use client'

import { usePathname } from 'next/navigation'
import { Button } from '@/frontend/design-system/actions/Button'

export function LoginButton() {
  const pathname = usePathname()
  const href = `/auth/login?redirectTo=${encodeURIComponent(pathname)}`

  return (
    <Button href={href} className='hidden md:block'>
      Zaloguj się
    </Button>
  )
}
